export default __webpack_public_path__ + "locales/lv/Settings.json?hash=f3b426897339e367e6e51a7ce6215667";